export default ({
  pageState: { editorBlocks },
  data: { blockId, blockData, editor, updatedAt }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: blockData,
        editor,
        updatedAt
      }
    },
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
